export default {
  name: 'BusinessFooter',
  data() {
    return {};
  }
};